import {IUserLocalStorageService} from "./user-local-storage.service.interface";
import {NullableString, UndefinedString} from "../../../types/nullable-types";
import {UserLocalStorageKeys} from "./user-local-storage-keys";
import {EmbeddedStorage} from "../embedded-storage";
import {EnvLocalStorageKeys} from "../environment-local-storage/environment-local-storage-keys";
import {Lazy} from "../../../utils/lazy";
import {ServiceBase} from "../../service-base";
import {IStorageOptions} from "../storage.interface";

export class UserLocalStorageService extends ServiceBase implements IUserLocalStorageService {

    private readonly _userLocalStorage: Lazy<EmbeddedStorage<UserLocalStorageKeys, EnvLocalStorageKeys>> =
        new Lazy<EmbeddedStorage<UserLocalStorageKeys, EnvLocalStorageKeys>>(() => {
            return new EmbeddedStorage<UserLocalStorageKeys, EnvLocalStorageKeys>({
                parentStorage: this.services.envLocalStorage,
                parentStorageKey: EnvLocalStorageKeys.UserLocalStorage,
                getStorageDiscriminator: () => this.services.user.profile.userNameHash,
            })
        });

    private get userLocalStorage(): EmbeddedStorage<UserLocalStorageKeys, EnvLocalStorageKeys> {
        return this._userLocalStorage.value;
    }

    private _composeOldKey(key: UserLocalStorageKeys, discriminator: UndefinedString): string {
        if(discriminator) {
            return `${key}.${this.services.configuration.currentEnvironmentType}.${discriminator}`;
        } else {
            return `${key}.${this.services.configuration.currentEnvironmentType}`;
        }
    }



    getItem(key: UserLocalStorageKeys, options?: IStorageOptions): NullableString {
        const oldKey = this._composeOldKey(key, options?.discriminator);

        const existingData = localStorage.getItem(oldKey);
        if(existingData) {
            localStorage.removeItem(oldKey);
            this.userLocalStorage.setItem(key, existingData, options);
            return existingData;
        } else {
            return this.userLocalStorage.getItem(key, options);
        }
    }

    setItem(key: UserLocalStorageKeys, value: string, options?: IStorageOptions): void {
        this.userLocalStorage.setItem(key, value, options);
    }
    setJson(key: UserLocalStorageKeys, value: any, options?: IStorageOptions): void {
        this.userLocalStorage.setJson(key, value, options);
    }
    getJson<TValue = any>(key: UserLocalStorageKeys, options?: IStorageOptions): TValue | null {
        const oldKey = this._composeOldKey(key, options?.discriminator);
        const existingData = localStorage.getItem(oldKey);
        if(existingData) {
            const value: TValue = JSON.parse(existingData);
            localStorage.removeItem(oldKey);
            this.userLocalStorage.setJson(key, value, options);
            return value;
        } else {
            return this.userLocalStorage.getJson(key, options);
        }
    }

    removeItem(key: UserLocalStorageKeys, options?: IStorageOptions): void {
        this.userLocalStorage.removeItem(key, options);
    }

}
